// format-name.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatName',
  standalone: true
})
export class FormatNamePipe implements PipeTransform {
  transform(name: string | null | undefined): string {
    if (!name) return '';

    const words = name.trim().split(' ');

    if (words.length === 0) return '';
    if (words.length === 1) {
      return words[0].toUpperCase();
    }

    // Premier mot : tout en majuscule
    const firstWord = words[0].toUpperCase();

    // À partir du deuxième mot : première lettre en majuscule, reste en minuscule
    const otherWords = words.slice(1).map(word =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');

    return [firstWord, otherWords].filter(Boolean).join(' ');
  }
}
